// the site's other pages (About, Rules, Privacy) in the language picked in the menu: see pageLanguage.ts (1.04.4)
import { translatePage } from "./pageLanguage";

void translatePage();
